<template>
    <div>
        <el-form-item class="form-color-item" prop="name" :label="field.name + '：'" label-width="110px">
            <el-color-picker v-model="val[0]"></el-color-picker>
            <el-color-picker v-model="val[1]"></el-color-picker>
        </el-form-item>
    </div>
</template>


<script>

  export default {
    name: 'tms-type-gradient-color',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      source: {
        type: String,
      }
    },
    computed: {
      val(){
        // 初始化， array类型不存在报错
        const val = this.config[this.field.key]
        if(!Array.isArray(val)) {
          return []
        }
        return val
      },
       config() {
        if (this.source === 'tmsPageConfig') {
          return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
          return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
  }

</script>
